import { FC } from 'react';

import SingularTracker from 'common/services/trackers/singular';

import { APButton, ApImage } from 'common/components';
import { DownloadBySystems } from 'common/components/download-app/systems';
import { OS_SYSTEM } from 'common/helpers/utils';

import { useDownloadButtonStyles } from './download-button-styles';

interface DownloadButtonProps {
  system: OS_SYSTEM.ANDROID | OS_SYSTEM.IOS;
  size?: 'sm' | 'lg';
}

const DownloadButton: FC<DownloadButtonProps> = ({ system, size = 'lg' }) => {
  const classes = useDownloadButtonStyles();

  const dataSystem = DownloadBySystems[system];

  return (
    <APButton
      id={`btn-download-${system.toLowerCase()}`}
      focusRipple
      key={`download-button-${system.toLowerCase()}`}
      className={classes.imageContainer}
      variant="text"
      onClick={() => {
        window.location.href = SingularTracker.getUrlToDownloadApp();
      }}
    >
      <ApImage
        className={`${classes.image} ${size}`}
        src={dataSystem.image}
        alt={dataSystem.text}
      />
    </APButton>
  );
};

export default DownloadButton;
